"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrushExtension = exports.BrushBehavior = exports.DefaultBrushExtensionParams = void 0;
var tslib_1 = require("tslib");
var class_names_1 = require("../class-names");
var d3 = tslib_1.__importStar(require("../d3-modules"));
var extension_1 = require("../extension");
var scales_1 = require("../scales");
/** Default parameter values for `BrushExtension` */
exports.DefaultBrushExtensionParams = {
  enabled: false,
  snap: true,
  closeButton: true
};
/** Behavior class for `BrushExtension` (allows selecting a rectangular region by mouse brush gesture; not compatible with zooming!) */
var BrushBehavior = /** @class */function (_super) {
  tslib_1.__extends(BrushBehavior, _super);
  function BrushBehavior() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** D3 brush behavior */
    _this.brushBehavior = d3.brush().on('start', function (event) {
      return _this.handleBrushStart(event);
    }).on('brush', function (event) {
      return _this.handleBrushBrush(event);
    }).on('end', function (event) {
      return _this.handleBrushEnd(event);
    });
    return _this;
  }
  Object.defineProperty(BrushBehavior.prototype, "svg", {
    get: function () {
      var _a;
      return (_a = this.state.dom) === null || _a === void 0 ? void 0 : _a.svg;
    },
    enumerable: false,
    configurable: true
  });
  BrushBehavior.prototype.register = function () {
    var _this = this;
    _super.prototype.register.call(this);
    this.subscribe(this.state.events.render, function () {
      if (_this.params.enabled) _this.addBrushBehavior();
    });
  };
  BrushBehavior.prototype.update = function (params) {
    _super.prototype.update.call(this, params);
    if (this.params.enabled && !this.targetElement) this.addBrushBehavior();
    if (!this.params.enabled && this.targetElement) this.removeBrushBehavior();
    if (this.currentSelection) {
      if (this.params.snap) {
        this.currentSelection = scales_1.Box.snap(this.currentSelection, 'out', this.state.boxes.wholeWorld);
        this.brushBehavior.move(this.targetElement, this.worldBoxToBrushSelection(this.currentSelection));
        this.state.events.brush.next({
          type: 'end',
          selection: this.state.worldBoxToBoxSelection(this.currentSelection),
          sourceEvent: undefined
        });
      }
      this.placeCloseButton(this.currentSelection);
    }
  };
  BrushBehavior.prototype.unregister = function () {
    this.removeBrushBehavior();
    _super.prototype.unregister.call(this);
  };
  /** Bind brush behavior (also remove any existing) */
  BrushBehavior.prototype.addBrushBehavior = function () {
    var _this = this;
    if (!this.svg) return;
    this.removeBrushBehavior();
    this.targetElement = this.svg.append('g').attr('class', 'brush-target').call(this.brushBehavior);
    d3.select(document).on('keydown.BrushExtension', function (event) {
      if (event.key === 'Escape') _this.deselect(event);
    });
  };
  /** Remove existing brush behavior (if any) */
  BrushBehavior.prototype.removeBrushBehavior = function () {
    if (this.targetElement) {
      if (this.state.events.brush.value.selection) {
        this.deselect();
      }
      this.targetElement.remove();
      this.targetElement = undefined;
      d3.select(document).on('keydown.BrushExtension', null);
    }
  };
  BrushBehavior.prototype.handleBrushStart = function (event) {
    if (!event.sourceEvent) return; // avoid infinite loop
    var worldBox = this.brushSelectionToWorldBox(event.selection);
    this.placeCloseButton(undefined);
    this.currentBrushAction = (worldBox === null || worldBox === void 0 ? void 0 : worldBox.xmin) === (worldBox === null || worldBox === void 0 ? void 0 : worldBox.xmax) && (worldBox === null || worldBox === void 0 ? void 0 : worldBox.ymin) === (worldBox === null || worldBox === void 0 ? void 0 : worldBox.ymax) ? 'create' : 'update';
    this.currentSelection = undefined;
    this.state.events.brush.next({
      type: 'start',
      selection: this.state.worldBoxToBoxSelection(worldBox),
      sourceEvent: event
    });
  };
  BrushBehavior.prototype.handleBrushBrush = function (event) {
    if (!event.sourceEvent) return; // avoid infinite loop
    var worldBox = this.brushSelectionToWorldBox(event.selection);
    this.state.events.brush.next({
      type: 'brush',
      selection: this.state.worldBoxToBoxSelection(worldBox),
      sourceEvent: event
    });
  };
  BrushBehavior.prototype.handleBrushEnd = function (event) {
    if (!event.sourceEvent) return; // avoid infinite loop
    var worldBox = this.brushSelectionToWorldBox(event.selection);
    if (this.params.snap) {
      var snapStrategy = this.currentBrushAction === 'update' ? 'nearest' : 'out';
      worldBox = scales_1.Box.snap(worldBox, snapStrategy, this.state.boxes.wholeWorld);
      this.brushBehavior.move(this.targetElement, this.worldBoxToBrushSelection(worldBox));
    }
    this.placeCloseButton(worldBox);
    this.state.events.brush.next({
      type: 'end',
      selection: this.state.worldBoxToBoxSelection(worldBox),
      sourceEvent: event
    });
    this.currentSelection = worldBox;
    this.currentBrushAction = undefined;
  };
  /** Add or remove "Close" icon */
  BrushBehavior.prototype.placeCloseButton = function (worldBox) {
    var _this = this;
    var BUTTON_SIZE = 16;
    var canvasPosition = worldBox ? {
      x: Math.min(this.state.scales.worldToCanvas.x(worldBox.xmax), this.state.boxes.canvas.xmax - 0.7 * BUTTON_SIZE),
      y: Math.max(this.state.scales.worldToCanvas.y(worldBox.ymin), this.state.boxes.canvas.ymin + 0.7 * BUTTON_SIZE)
    } : undefined;
    if (!this.svg) return;
    this.svg.selectAll(".".concat(class_names_1.Class.BrushClose)).remove();
    if (this.params.closeButton && canvasPosition) {
      var group = this.svg.append('g').classed(class_names_1.Class.BrushClose, true).attr('transform', "translate(".concat(canvasPosition.x, " ").concat(canvasPosition.y, ") scale(").concat(BUTTON_SIZE / 24, ")")).on('mousemove', function (e) {
        // avoid default hover behavior
        _this.state.events.hover.next({
          cell: undefined,
          sourceEvent: e
        });
        e.stopPropagation();
      }).on('click', function (e) {
        _this.deselect();
        e.stopPropagation(); // avoid messing up with pinnable tooltips
      });
      group.append('circle').classed('circle', true).attr('cx', 0).attr('cy', 0).attr('r', 14);
      group.append('path').classed('cross', true).attr('d', 'M7,-5.59 L5.59,-7 L0,-1.41 L-5.59,-7 L-7,-5.59 L-1.41,0 L-7,5.59 L-5.59,7 L0,1.41 L5.59,7 L7,5.59 L1.41,0 L7,-5.59 Z');
    }
  };
  BrushBehavior.prototype.deselect = function (event) {
    this.brushBehavior.clear(this.targetElement);
    this.placeCloseButton(undefined);
    this.state.events.brush.next({
      type: 'end',
      selection: undefined,
      sourceEvent: event
    });
    this.currentSelection = undefined;
  };
  BrushBehavior.prototype.brushSelectionToWorldBox = function (selection) {
    if (!selection) return undefined;
    var _a = selection[0],
      left = _a[0],
      top = _a[1],
      _b = selection[1],
      right = _b[0],
      bottom = _b[1];
    var canvasToWorld = this.state.scales.canvasToWorld;
    return {
      xmin: canvasToWorld.x(left),
      xmax: canvasToWorld.x(right),
      ymin: canvasToWorld.y(top),
      ymax: canvasToWorld.y(bottom)
    };
  };
  BrushBehavior.prototype.worldBoxToBrushSelection = function (worldBox) {
    if (!worldBox) return null;
    var worldToCanvas = this.state.scales.worldToCanvas;
    return [[worldToCanvas.x(worldBox.xmin), worldToCanvas.y(worldBox.ymin)], [worldToCanvas.x(worldBox.xmax), worldToCanvas.y(worldBox.ymax)]];
  };
  return BrushBehavior;
}(extension_1.BehaviorBase);
exports.BrushBehavior = BrushBehavior;
/** Adds behavior that highlights hovered grid cell and column and row */
exports.BrushExtension = extension_1.Extension.fromBehaviorClass({
  name: 'builtin.brush',
  defaultParams: exports.DefaultBrushExtensionParams,
  behavior: BrushBehavior
});